"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkScheduleEntry = exports.isScheduleEntry = void 0;
const __1 = require("..");
function isScheduleEntry(object) {
    return checkScheduleEntry(object).fulfilled;
}
exports.isScheduleEntry = isScheduleEntry;
function checkScheduleEntry(object, options = { ignoreSuperfluousObjectProperties: true }) {
    const result = (0, __1.check)(object, (0, __1.hasString)("id"), (0, __1.hasNumber)("creationDate").integer().optional(), (0, __1.hasNumber)("startTime").integer(), (0, __1.hasNumber)("endTime").integer(), (0, __1.hasString)("userId").optional(), (0, __1.hasString)("resourceId").optional(), (0, __1.hasString)("typeId").optional(), (0, __1.hasString)("projectId").optional(), (0, __1.hasString)("comment").optional()).withOptions(options).explain();
    if (!object.userId && !object.resourceId) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$",
            explanation: "requires either userId or resourceId fields",
            value: undefined,
        });
    }
    if (object.userId && object.resourceId) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$.resourceId",
            explanation: "cannot be set if userId is set",
            value: object.resourceId,
        });
    }
    if (!object.typeId && !object.projectId) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$",
            explanation: "requires either typeId or projectId fields",
            value: undefined,
        });
    }
    if (object.typeId && object.projectId) {
        result.fulfilled = false;
        result.reasons = result.reasons || [];
        result.reasons.push({
            path: "$.projectId",
            explanation: "cannot be set if typeId is set",
            value: object.projectId,
        });
    }
    return result;
}
exports.checkScheduleEntry = checkScheduleEntry;
//# sourceMappingURL=ScheduleEntry.js.map